export default __webpack_public_path__ + "static/media/footer-near-logo.2d4a6e76.svg";